import { User } from '../../lib/types/models/users/user'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getMe() {
  return restApiClient.url(constructApiUrl(API.user.getMe.url, null)).get<User>()
}
